"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var export_button_html_1 = __importDefault(require("../../../components/toolbar/export-button/EE-overrides/export-button.html"));
var override_utils_1 = require("@services/overrides/override-utils");
var translations_1 = require("@shared/constants/translations");
(function (module) {
    'use strict';
    module.service('prEEOverride', [
        'prOverrideRegister',
        'pr.OVERRIDE_EVENTS',
        '$filter',
        '$injector',
        'pr.CUSTOM_FILTER_FIELDS',
        '$q',
        function (registerOverride, OVERRIDE_EVENTS, $filter, $injector, CUSTOM_FILTER_FIELDS, $q) {
            var translate = $filter('translate');
            var DISABLED_WIDGETS = ['eng.heatmap'];
            var overrideUtils = new override_utils_1.OverrideUtils($filter, $injector);
            function getDashboard() {
                var activeReport = $injector.get('prActiveReport');
                var env = $injector.get('rsEnvironment');
                return env.get('dashboard') || activeReport.getMetadata('dashboard') || {};
            }
            // constants
            registerOverride(OVERRIDE_EVENTS.CONFIG_FLAGS, _.constant({
                autoOpenCreateReportModal: true,
                disableDataSource: true,
                disableMedianMetric: true,
                disablePreview: true,
                disableReportCreation: true,
                disableReportErrorMessageButtons: true,
                disableReportFilters: true,
                disableResponseCount: true,
                disableSharing: true,
                disableTimezone: true,
                disableWeighting: true,
                disableWidgetExports: true,
                enableDynamicTranslations: true,
                enableScaleColorPalette: true,
                shouldUseUserLanguage: true,
                useEIWidgetServiceLanguages: true,
                widgetCountLimit: 500
            }));
            registerOverride(OVERRIDE_EVENTS.CREATE_REPORT_MESSAGE, _.constant('CREATE_A_REPORT_TEMPLATE'));
            registerOverride(OVERRIDE_EVENTS.NO_REPORTS_MESSAGE, _.constant('NO_REPORTS_FOR_DASHBOARD'));
            registerOverride(OVERRIDE_EVENTS.CUSTOM_HEADER_TEMPLATE, _.constant('<pr-ee-header></pr-ee-header>'));
            // EE fieldsets don't have AuthorizationService
            // but EE users should be able to modify widget-level filters
            // So force allow filter permissions
            registerOverride(OVERRIDE_EVENTS.FILTER_PERMISSIONS, _.constant({
                readOnly: false,
                viewPersonalData: true
            }));
            // functions
            registerOverride(OVERRIDE_EVENTS.LANGUAGE_CODES, function (languageCodes) {
                var allLanguageCodes = _.keys(translations_1.LANG_LOCALE_MAPPING);
                var combinedCodes = languageCodes.concat(allLanguageCodes);
                return _.uniq(combinedCodes);
            });
            registerOverride(OVERRIDE_EVENTS.SINGLE_FIELDSET, function () {
                return getDashboard().fieldsetId;
            });
            registerOverride(OVERRIDE_EVENTS.PIPED_TEXT_MENU, function (menu) {
                // Add Org Hierarchy menu item 
                var PipedTextEeMenu = $injector.get('prPipedTextEeMenuService');
                var eeMenu = new PipedTextEeMenu();
                menu.items.push({
                    label: $filter('translate')('ORG_HIERARCHY'),
                    submenu: {
                        items: eeMenu.getMenu(menu.action)
                    }
                });
                // EE only supports one project, so don't include list of data sources
                _.remove(menu.items, {
                    label: translate('PIPED_TEXT.SOURCES')
                });
                // EE projects use dashboard data, not survey data
                var menuItem = _.find(menu.items, {
                    label: translate('SURVEY_DATA')
                });
                menuItem.label = translate('DASHBOARD_DATA');
                return menu;
            });
            registerOverride(OVERRIDE_EVENTS.SOURCE_DATA_MENU, function () {
                var sourceId = getDashboard().fieldsetId;
                var FieldMenu = $injector.get('prFieldMenu');
                return new FieldMenu(sourceId).get({
                    filter: [
                        'ScalarValue',
                        'EnumerableScalarValue',
                        'EnumerableValue',
                        'EnumerableValueSet',
                        'FreeFormText',
                        'Geometry',
                        'GenericValue',
                        'Category'
                    ],
                    questionsAsSubmenu: true,
                    disableDivider: true,
                    fieldAsValue: true,
                    includeIcon: true,
                    includeAllChoices: true,
                    replaceCheck: true
                }).then(function (menu) {
                    menu[0].submenu.filterable = true;
                    return menu;
                });
            });
            registerOverride(OVERRIDE_EVENTS.EXPORT_BUTTON, function (data) {
                return _.assign(data, {
                    templateUrl: export_button_html_1.default,
                    controller: 'prEeExportButtonController'
                });
            });
            registerOverride(OVERRIDE_EVENTS.INSERT_MENU, function (menu) {
                // Change 'Survey Data' to 'Dashboard Data'
                var questionHeader = _.find(menu, {
                    header: translate('SURVEY_DATA')
                });
                if (questionHeader) {
                    questionHeader.header = translate('DASHBOARD_DATA');
                }
                overrideUtils.removeDisabledWidgets(menu, DISABLED_WIDGETS);
                overrideUtils.removeDisabledFields(menu, DISABLED_WIDGETS);
                return menu;
            });
            registerOverride(OVERRIDE_EVENTS.SWITCH_OPTIONS, function (switchOptions) {
                overrideUtils.removeItems(switchOptions, function (item) {
                    return _.includes(DISABLED_WIDGETS, item);
                });
                return switchOptions;
            });
            registerOverride(OVERRIDE_EVENTS.WIDGET_CONFIG_INIT, function (data) {
                overrideUtils.updateInitWidgetConfig(data, DISABLED_WIDGETS);
                return data;
            });
            /**
             * Remove the list of data sources from the filters menu.
             * EE reports only support one data source.
             */
            registerOverride(OVERRIDE_EVENTS.PAGE_FILTER_MENU, function (menu) {
                var actionFunc = _.get(menu, '1.submenu.action');
                var itemsFunc = _.get(menu, '1.submenu.items');
                if (!_.isFunction(itemsFunc) || !_.isFunction(actionFunc)) {
                    return $q.when(menu);
                }
                return itemsFunc().then(function (items) {
                    return _.map(items, function (item) {
                        if (!item.divider) {
                            item.action = actionFunc;
                        }
                        return item;
                    });
                });
            });
            registerOverride(OVERRIDE_EVENTS.NEW_CONTAINER_DEFINITION, function (containerDef) {
                var dashboard = getDashboard();
                var fieldsetId = dashboard.fieldsetId;
                containerDef.product = 'printed-reports-EE';
                containerDef.fieldSetId = fieldsetId;
                containerDef.contextMeta.surveyId.push(fieldsetId);
                containerDef.contextMeta.dashboard = dashboard;
                return containerDef;
            });
            registerOverride(OVERRIDE_EVENTS.CREATE_REPORT_OPTIONS, function (createReportOptions) {
                _.remove(createReportOptions, {
                    label: translate('FROM_RESULTS_REPORT')
                });
                _.forEach(createReportOptions, function (options) {
                    if (options.label === translate('NEW_REPORT')) {
                        options.label = translate('NEW_REPORT_TEMPLATE');
                    }
                });
                return createReportOptions;
            });
            registerOverride(OVERRIDE_EVENTS.REPORT_ERROR, function (error) {
                if (error) {
                    return error;
                }
                if (!getDashboard().fieldsetId) {
                    return 'NO_DASHBOARD';
                }
            });
            registerOverride(OVERRIDE_EVENTS.DATA_REQUEST_OPTIONS, function (data) {
                var requestOptions = data.requestOptions;
                var doubleBreakoutWidgets = ['eng.bar', 'eng.line', 'eng.table'];
                var isDoubleBreakout = requestOptions.metrics.length === 1 &&
                    _.get(requestOptions, 'metrics.0.breakouts.length') === 1 &&
                    requestOptions.breakouts.length === 1 &&
                    _.includes(doubleBreakoutWidgets, data.shape.type);
                if (!isDoubleBreakout) {
                    return data;
                }
                var widgetManager = $injector.get('pr.widgetManager');
                var component = widgetManager.getWidgetComponent(data.shape.widgetId);
                var viewConfig = component.lifecycle.viewConfig;
                requestOptions.swapBreakouts = !viewConfig.transposeData;
                return data;
            });
            registerOverride(OVERRIDE_EVENTS.FILTERS_CLIENT_FIELDSET_DEF, function (fieldsetDef) {
                var $routeParams = $injector.get('$routeParams');
                var fieldsetService = $injector.get('prFieldsets');
                var activeSurveyId = $routeParams.surveyId;
                fieldsetDef.fieldSetView.push({
                    fieldId: CUSTOM_FILTER_FIELDS.SOURCE_ID,
                    name: '',
                    description: translate('DATA_SET_SOURCE'),
                    type: 'Custom',
                    labels: true,
                    meta: {}
                });
                return fieldsetService.getFieldsetBySourceId(activeSurveyId).then(function (surveyFieldset) {
                    fieldsetDef.fieldSetLabels = surveyFieldset.labels;
                    fieldsetDef.contextMeta.sourceSurveyId = activeSurveyId;
                    // remove category fields from filter menu items
                    fieldsetDef.fieldSetView = _.filter(fieldsetDef.fieldSetView, function (fieldView) {
                        var fullType = _.get(fieldView, 'meta.fullType');
                        return fullType !== 'TagGroup';
                    });
                    return fieldsetDef;
                });
            });
            registerOverride(OVERRIDE_EVENTS.IMAGE_POSITIONS, function (imagePositions) {
                // https://qualtrics.atlassian.net/browse/REP-5418
                return _.omit(imagePositions, 'fill');
            });
        }
    ]);
})(angular.module('qualtrics.pr'));
